import useAxios from "axios-hooks";
import React, { useState } from "react";
import Error from "../components/Error";
import FormWrapper from "../components/styles/FormWrapper";
import InputFormContainer from "../components/styles/InputFormContainer";
import QueryLoading from "../components/animations/QueryLoading";
import { API_URL } from "../config";

const ForgotPage = () => {
  const [{ loading }, requestReset] = useAxios(
    {
      url: `${API_URL}/requestReset`,
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const [success, setsuccess] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [email, setemail] = useState("");
  if (success) {
    return (
      <InputFormContainer>
        <div className="text-align-center">
          An email has been sent to {email}
        </div>
      </InputFormContainer>
    );
  } else {
    return (
      <>
        {loading ? (
          <QueryLoading />
        ) : (
          <InputFormContainer>
            <FormWrapper
              onSubmit={(event) => {
                event.preventDefault();
                requestReset({ data: { email } })
                  .then(() => {
                    setsuccess(true);
                  })
                  .catch((error) => {
                    console.log(error);
                    seterrorMessage(`No account found with email ${email}`);
                  });
              }}
            >
              <p>
                <label htmlFor="email">Email address</label>

                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={(event) => setemail(event.target.value)}
                />
              </p>
              {errorMessage && <Error message={errorMessage} />}
              <button type="submit">Request reset</button>
            </FormWrapper>
          </InputFormContainer>
        )}
      </>
    );
  }
};

export default ForgotPage;
